import RoutesMap from '../../route_control/RouteControl'
import { PaymentTransactionList } from '../../pages/amount'

export const AmountRouteImport = {
    RoutesMap,
    PaymentTransactionList,
}
